import PropTypes from 'prop-types';

export const TPeriod = {
  professional: PropTypes.string,
  photo: PropTypes.string,
  mimetype: PropTypes.string,
  periods: PropTypes.arrayOf(PropTypes.shape({})),
};
